import { compose, createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import rootReducers from './reducers/index';

export default (props) => {
  const middlewares = [thunk];
  const composedStore = compose(
    applyMiddleware(...middlewares),
  );

  return composedStore(createStore)(rootReducers, { mainreducer: props });
};
